<template>
  <div>
    <header id="site-header" class="fixed-top d-none d-lg-block">
      <!-- Start Header Bottom -->
      <div class="header-bottom sticky-header">
        <div class="container">
          <div class="row justify-content-between align-items-center">
            <div class="col-auto">
              <div class="logo">
                <a href="./">
                <img :src="companyInfo.logoImg" alt=""/>
                </a>
              </div>
            </div>
            <div class="col-auto">
              <ul class="header-nav">
                <li
                  class="has-dropdown"
                  v-for="(item, index) in menuList"
                  :key="index"
                >
                  <router-link style="font-size:16px" :to="'/' + item.path">
                    {{ item.menuName }}
                  </router-link>
                  <ul v-if="item.children != undefined" class="submenu">
                    <li v-for="(items, inde) in item.children" :key="inde">
                        <router-link style="font-size:16px" :to="'/' + item.path+'?selectid='+items.path">
                            {{ items.menuName }}
                        </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="top_lang">Language: 
                        <a href="http://wonterfull.cn/" title="Chinese"><img src="../../../assets/images/chinese.gif" alt="Chinese"></a>
                        ∷&nbsp;
                        <a href="http://wonterfull.com/" title="English"><img src="../../../assets/images/english.gif" alt="English"></a>
</div>
      </div>
    </header>

    <div id="site-header1" class="fixed-top mobile-header d-block d-lg-none">
      <div class="container">
        <div class="row align-items-center justify-content-between">
          <div class="col">
            <div class="mobile-logo">
              <a href="/"
                ><img
                  style="width: 100%"
                  :src="companyInfo.logoImg"
                  alt=""
              /></a>
            </div>
          </div>
          <div class="col">
            <div class="mobile-action-link text-end">
              <!-- 菜单 -->
              <a
                href="#mobile-menu-offcanvas"
                @click="menus"
                class="offcanvas-toggle offside-menu iconfont icon-caidan"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="mobile-menu-offcanvas"
      class="offcanvas offcanvas-rightside offcanvas-mobile-menu-section"
    >
      <!-- Start Offcanvas Header -->
      <div class="offcanvas-header text-left">
        <button class="offcanvas-close iconfont icon-guanbi"></button>
      </div>
      <div class="offcanvas-mobile-menu-wrapper">
        <!-- Start Mobile Menu  -->
        <div class="mobile-menu-bottom">
          <!-- Start Mobile Menu Nav -->
          <div class="offcanvas-menu">
            <ul>
              <li v-for="(item,index) in menuList" :key="index">
                  <router-link :to="'/' + item.path">
                    <span>{{ item.menuName }}</span>
                  </router-link>
                
                <ul v-if="item.children != undefined" class="mobile-sub-menu">
                  <li v-for="(items, inde) in item.children" :key="inde">
                      <router-link :to="'/' + item.path+'?selectid='+items.path">
                            {{ items.menuName }}
                        </router-link>
                    </li>
                </ul>
              </li>

              
            </ul>
          </div>
<div class="top_langm">Language: 
                        <a href="http://wonterfull.cn/" title="Chinese"><img src="../../../assets/images/chinese.gif" alt="Chinese"></a>
                        ∷&nbsp;
                        <a href="http://wonterfull.com/" title="English"><img src="../../../assets/images/english.gif" alt="English"></a>
</div>          
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $window = $(window),
  $body = $("body");
import { getBookList, updateBook } from "@/api/common"; //路径
import { listMenu } from "@/api/menu/index.js";
import { listCompanyInfo } from "@/api/companyInfo/companyInfo.js";
export default {
  data() {
    return {
      menuList: [],
      companyInfo:{}
    };
  },
  created() {},
  mounted() {
    this.getMenuList();
  this.getCompanyInfo();
    this.fullHeight();
    // this.companyInfo = JSON.parse(localStorage.getItem("companyInfo"))
  },
  methods: {
    getMenuList() {
   
      listMenu().then((res) => {
        this.menuList = this.handleTree(res.rows, "id");
        
        /** 排序 */
        this.menuList = this.menuList.sort((a , b) =>{
          return a.orderNum - b.orderNum;
        })

        /** 进行排序 */
        const children = this.menuList[1].children;

        var childrens = children.sort((a, b) => {
          return a.orderNum - b.orderNum;
        });

        this.menuList[1][children] = childrens

        console.log(this.menuList)

        
        setTimeout(() => {
            this.menus();
            this.mobileOffCanvasMenu();
        }, 500);
        
        
      });
    },
    getCompanyInfo(){
        listCompanyInfo(this.queryParams).then(res =>{
            this.companyInfo = res.rows[0]
        })
    },
    jump(bigPath, litPath) {
      if (this.$route.path !== "/" + bigPath) {
        this.$router.push({
          path: bigPath,
          params: {
            selectId: litPath,
          },
        });
      }
    },

    // 获取下滑高度 并设置
    fullHeight() {
      $(window).on("scroll", function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 80) {
          $("#site-header").addClass("nav-fixed");
          $("#site-header1").addClass("nav-fixed");
        } else {
          $("#site-header").removeClass("nav-fixed");
          $("#site-header1").removeClass("nav-fixed");
        }
      });
    },
    menus() {
      var $offCanvasToggle = $(".offcanvas-toggle"),
        $offCanvas = $(".offcanvas"),
        $offCanvasOverlay = $(".offcanvas-overlay"),
        $mobileMenuToggle = $(".mobile-menu-toggle");
      $offCanvasToggle.on("click", function (e) {
        e.preventDefault();
        var $this = $(this),
          $target = $this.attr("href");
        $body.addClass("offcanvas-open");
        $($target).addClass("offcanvas-open");
        $offCanvasOverlay.fadeIn();
        if ($this.parent().hasClass("mobile-menu-toggle")) {
          $this.addClass("close");
        }
      });
      $(".offcanvas-close, .offcanvas-overlay").on("click", function (e) {
        e.preventDefault();
        $body.removeClass("offcanvas-open");
        $offCanvas.removeClass("offcanvas-open");
        $offCanvasOverlay.fadeOut();
        $mobileMenuToggle.find("a").removeClass("close");
      });
    },
    mobileOffCanvasMenu() {
      var $offCanvasNav = $(".offcanvas-menu"),
        $offCanvasNavSubMenu = $offCanvasNav.find(".mobile-sub-menu");

      /*Add Toggle Button With Off Canvas Sub Menu*/
      $offCanvasNavSubMenu
        .parent()
        .prepend(
          '<div class="offcanvas-menu-expand iconfont icon-you-"></div>'
        );

      /*Category Sub Menu Toggle*/
      $offCanvasNav.on("click", "li a, .offcanvas-menu-expand", function (e) {
        var $this = $(this);
        if (
          $this.attr("href") === "#" ||
          $this.hasClass("offcanvas-menu-expand")
        ) {
          e.preventDefault();
          if ($this.siblings("ul:visible").length) {
            $this.parent("li").removeClass("active");
            $this.siblings("ul").slideUp();
            $this.parent("li").find("li").removeClass("active");
            $this.parent("li").find("ul:visible").slideUp();
          } else {
            $this.parent("li").addClass("active");
            $this
              .closest("li")
              .siblings("li")
              .removeClass("active")
              .find("li")
              .removeClass("active");
            $this.closest("li").siblings("li").find("ul:visible").slideUp();
            $this.siblings("ul").slideDown();
          }
        }
      });
    },
  },
};
</script>

<style>
.top_lang {
    float: right;
    height: 34px;
    padding: 6px 10px 0px 10px;
	color:#fff;
	position: relative;
    top: -98px;
}
.nav-fixed .top_lang{color:#651984;}
.top_langm {
    float: left;
    height: 34px;
    padding: 6px 10px 0px 6px;
	color:#fff;
}
.top_langm img{width:68px;}
</style>